import {isBrowser} from './isBrowser';
import {isProductionDomain} from './isProductionDomain';

export const isProduction =
  isBrowser && isProductionDomain(window.location.hostname);
